<template>
	<div>
		<navigation msg="下级运营商/设备信息" />
		<router-view />
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default {
		data() {
			return {
	
			}
		},
		components: {
			navigation
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/oper/mac/home.vue